var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length)?_c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag){return _c('router-link',{key:tag,staticClass:"mr-1 link",attrs:{"to":{
      name: 'Tag',
      params: {
        name: tag,
      },
    }}},[_vm._v(" #"+_vm._s(tag)+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }